const USDT = ({ gradient, id }) => {
  return (
    <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg">
      <path fill="#26A17B" d="M0 0h18v18H0z" />
      <path
        d="M10 10.499c-.053 0-.319.021-.99.021-.537 0-.877-.016-1.01-.021-2.071-.092-3.658-.456-3.658-.895s1.587-.807 3.658-.9V10c.693.047 1.307.047 2 0V8.705c2.066.092 3.653.46 3.653.9 0 .433-1.587.802-3.653.894zm0-1.946V7h3V5H5v2h3v1.553c-2.343.108-4.143.585-4.143 1.149 0 .564 1.8 1.04 4.143 1.15V14h2v-3.149c2.342-.108 4.143-.585 4.143-1.149 0-.564-1.8-1.035-4.143-1.15z"
        fill="currentColor"
      />
    </svg>
  );
};

export default USDT;
